import { useTranslation } from 'react-i18next';

export const useContentSearch = (includeAdvancedTypes?: boolean, workshopsOnly?: boolean) => {
  const { t } = useTranslation();

  let contentTypeOptions = [
    {
      name: t('contentSearch.allTypes'),
      value: includeAdvancedTypes
        ? 'articles,videos,files,scorm,assessments,tracks,journeys,imported_content,workshops'
        : 'articles,videos,files,scorm,assessments',
    },
    { name: t('contentSearch.articles'), value: 'articles' },
    { name: t('contentSearch.videos'), value: 'videos' },
    { name: t('contentSearch.files'), value: 'files' },
    { name: t('contentSearch.scorms'), value: 'scorm' },
    { name: t('contentSearch.assessments'), value: 'assessments' },
  ];

  if (includeAdvancedTypes) {
    contentTypeOptions.push(
      { name: t('contentSearch.tracks'), value: 'tracks' },
      { name: t('contentSearch.journeys'), value: 'journeys' },
      { name: t('contentSearch.importedContent'), value: 'imported_content' },
      { name: t('contentSearch.workshops'), value: 'workshops' },
    );
  }

  let contentTypeMap: { [key: string]: string } = {
    article: t('contentSearch.article'),
    file: t('contentSearch.media'),
    video: t('contentSearch.media'),
    scorm: t('contentSearch.scorm'),
    assessment: t('contentSearch.assessment'),
    track: t('contentSearch.track'),
    journey: t('contentSearch.journey'),
    imported_content: t('contentSearch.importedContent'),
    workshop: t('contentSearch.workshop'),
    multi_session_workshop: t('contentSearch.multiSessionWorkshop'),
  };

  if (workshopsOnly) {
    contentTypeOptions = [{ name: t('contentSearch.workshops'), value: 'workshops' }];

    contentTypeMap = {
      workshop: t('contentSearch.workshop'),
    };
  }

  return {
    contentTypeOptions,
    contentTypeMap,
  };
};
